<script setup>
import { watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { default as ButtonEl } from '@/components/shared/Button.vue';
import SelectionTile from '@/components/shared/SelectionTile.vue';
import { useActivitiesStore } from '@/stores/activities';
import { useNewsStore } from '@/stores/news';
import { useMealsStore } from '@/stores/meals';
import { useGalleriesStore } from '@/stores/galleries';
import { cloneDeep } from 'lodash';
import { useInstitutionStore } from '@/stores/institution';

const route = useRoute();
const emit = defineEmits(['close']);
const institutionStore = useInstitutionStore();

const STORE_MAP = {
  ACTIVITIES: useActivitiesStore(),
  NEWS: useNewsStore(),
  MEAL_PLAN: useMealsStore(),
  GALLERY: useGalleriesStore(),
};

const store = STORE_MAP[route.name];
store.copy = cloneDeep(store.all);

watch(route, () => {
  reset();
});

const selectedInstitutionIds = computed(() => {
  return cloneDeep(store.uniqueInstitutions)
    .filter((inst) => inst.checked)
    .map((inst) => inst.id);
});

const reset = () => {
  store.all = store.allCopy;
  store.uniqueInstitutions.forEach((inst) => (inst.checked = true));
  emit('close');
};

const apply = () => {
  store.all = cloneDeep(store.allCopy).filter((item) =>
    selectedInstitutionIds.value.includes(item.institution.id)
  );

  emit('close');
};
</script>

<template>
  <div class="relative">
    <div
      v-if="store.uniqueInstitutions.length > 1"
      class="absolute shadow-lg bg-white border border-neutral-300 w-[540px] max-h-[700px] bottom-[92px] right-0 rounded-xl"
    >
      <p class="h700 text-center p-6">{{ $t('global.sort') }}</p>

      <div class="relative px-5 pb-5 overflow-y-scroll max-h-[388px]">
        <SelectionTile
          v-for="(institution, index) in store.uniqueInstitutions"
          :key="index"
          :title="institution.name"
          :image="institution.logo?.source"
          :checked="institution.checked"
          :isExternal="institutionStore.isExternalInstitution(institution.id)"
          @click="institution.checked = !institution.checked"
        />
      </div>

      <div class="flex p-5">
        <ButtonEl
          text="global.reset"
          background="bg-neutral-100"
          textColor="text-neutral-1000"
          rounded="full"
          class="w-1/2 mr-4"
          @click="reset"
        />

        <ButtonEl
          text="global.use"
          background="bg-darkOcean-600"
          rounded="full"
          class="w-1/2"
          @click="apply"
        />
      </div>
    </div>
  </div>
</template>
